import 'intersection-observer';
import lozad from 'lozad';

const App = {
  $doc: $(document),

  observer: {},

  init() {
    try {

      App.observer = lozad('.lozad', {
        rootMargin: '500px 0px',
        threshold: 0.1,
        load: function(el) {
          el.src = el.dataset.src;
          el.classList.add('loaded');
        },
      });

      App.observer.observe();

      App.$doc.on('lozad_observe', () => {
        App.observer.observe();
      });

    } catch (e) {
      console.error('Lozad: ', e);
    }
  }
};

export default App;



// WEBPACK FOOTER //
// assets/js/components/img-lazy-load.js